module.exports = __webpack_public_path__ + "a37e2a352c22a81739acef3fb1fbc4c9.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/accessibility/cc.svg
// module id = MbRD
// module chunks = 0